import React from 'react';

import { Box, Button, Paper } from '@mantine/core';
import { IconClipboardCheck, IconPlayerPlay } from '@tabler/icons-react';
import { NoDataFound } from 'components/NoDataFound';
import { useSmartAssistantVisualConfigExtractor } from 'hooks/use-smart-assistant-theme-extractor';
import { IndividualConversationView } from 'pages/ManageSmartAssistant/Sections/ConversationSections/ConversationsSection/IndividualConversationView';
import { useTranslation } from 'react-i18next';
import { EvaluationTest, EvaluationTestStatus } from 'shared/interfaces/Evaluation';
import { SmartAssistant } from 'shared/interfaces/SmartAssistant';

interface EvaluationTestViewProps {
  evaluationTest: EvaluationTest;
  smartAssistant: SmartAssistant;
  handleRunSpecificTests: (evaluationTestIds: string[]) => void;
  isGuest?: boolean;
}

export function EvaluationTestView({
  evaluationTest,
  smartAssistant,
  handleRunSpecificTests,
  isGuest = false
}: EvaluationTestViewProps) {
  const { t } = useTranslation();
  const smartAssistantVisualConfig = useSmartAssistantVisualConfigExtractor({ smartAssistant });

  const onRunEvaluationTestHandler = () => {
    handleRunSpecificTests([evaluationTest._id]);
  };

  const testResultConversation = evaluationTest.result?.conversation;

  return (
    <Paper withBorder radius="md" h="100%" w="100%" p="md" sx={{ overflow: 'hidden' }}>
      {testResultConversation ? (
        <Box h="100%" w="100%">
          <IndividualConversationView
            conversation={testResultConversation}
            smartAssistant={smartAssistant}
            smartAssistantVisualConfig={smartAssistantVisualConfig}
            // This callback isn't needed for this view
            onConversationUpdate={() => undefined}
            evaluationTestInfo={{
              onRunEvaluationTest: onRunEvaluationTestHandler,
              evaluationTest: evaluationTest
            }}
            isGuest={isGuest}
          />
        </Box>
      ) : (
        <NoDataFound
          icon={<IconClipboardCheck size={48} />}
          w="100%"
          h="100%"
          size="sm"
          title={t('NO_DATA_FOUND.EVALUATION_TEST_RESULTS.TITLE')}
          subTitle={t('NO_DATA_FOUND.EVALUATION_TEST_RESULTS.SUB_TITLE')}
          button={
            !isGuest ? (
              <Button
                loading={evaluationTest.status === EvaluationTestStatus.RUNNING}
                onClick={onRunEvaluationTestHandler}
                leftIcon={<IconPlayerPlay />}
                color="dark">
                {t('SMART_ASSISTANT.EVALUATIONS_SECTION.RUN_EVALUATION_TEST')}
              </Button>
            ) : undefined
          }
        />
      )}
    </Paper>
  );
}
